import { useCodeStore } from '@/core/stores/codeStore'
import type { ParameterData } from '@/core/types/library.type'
import { renderTypeUsage } from '@/core/utils/mappers/formatTypeUsage'

import styles from './CallableTitle.module.scss'

interface CallableTitleProps {
  name: string
  parameters: ParameterData[]
}

function getParameterTypeDisplay(parameter: ParameterData, technology: string | undefined): string {
  if (parameter.typeUsage) {
    const rendered = renderTypeUsage(parameter.typeUsage, technology || undefined)
    if (rendered) return rendered
  }
  return parameter.type
}

export const CallableTitle = ({ name, parameters }: CallableTitleProps) => {
  const selectedTechnology = useCodeStore((s) => s.selectedTechnology)

  const parametersString = parameters
    .map((parameter) => `${getParameterTypeDisplay(parameter, selectedTechnology)}: ${parameter.name}`)
    .join(', ')

  return (
    <span className={styles.callableTitle}>
      <span className={styles.name}>{name}</span>
      <span className={styles.parameters}>({parametersString})</span>
    </span>
  )
}
